import { getAlpha3Code, getSupportedLanguages } from 'i18n-iso-countries';

export function toCountryCode(countryName: string): string {
  for (const language of getSupportedLanguages()) {
    const countryCode = getAlpha3Code(countryName, language);
    if (countryCode) {
      return countryCode;
    }
  }

  return null;
}
